import { createContext } from 'react';

import { noop } from '@adsk/alloy-react-helpers';

import { TABLE_SIZE_THEMES, TABLE_SIZES } from './consts';
import { TableSize, TableSizeTheme } from './types';

type TableSizeThemeContextType = {
  tableSizeTheme: TableSizeTheme;
  setTableSizeTheme: (size: TableSize) => void;
  resetTableSizeTheme: () => void;
};

const TableSizeThemeContext = createContext<TableSizeThemeContextType>({
  // initial values set in the Provider
  tableSizeTheme: TABLE_SIZE_THEMES[TABLE_SIZES.MEDIUM],
  setTableSizeTheme: noop,
  resetTableSizeTheme: noop,
});

export default TableSizeThemeContext;
